exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".accountingPageContainer{background-color:#fff;width:660px;height:calc(100% - 100px);left:calc(100% - 660px);top:96px;position:absolute;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}", ""]);

